<template>
  <!--权限管理-->
  <div id="permissionManger">
    <div class="allMenuHead">
<!--      <div :style="{'left': step ? '25px' : '125px'}"  class="moveLine p_a"></div>-->
      <div v-if="$childMenu.indexOf('权限管理') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('authorityList', 1)" class="d_i headTab p_r">权限管理<div class="p_a" style="color:#ee1100;"></div></div>
      <div v-if="$childMenu.indexOf('人员角色') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('myPersonalRoleList', 2)" class="d_i headTab p_r">人员角色<div class="p_a" style="color:#ee1100;"></div></div>
<!--      <logName class="allLoginNamePlace"></logName>-->
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
export default {
  name: 'permissionManger',
  data () {
    return {
      step: 1
    }
  },
  created () {
    Time = setInterval(p => {
      if (window.location.href.indexOf('authorityList') >= 0) {
        this.step = 1
      } else if (window.location.href.indexOf('myPersonalRoleList') >= 0) {
        this.step = 2
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
  },
  methods: {
    toUrl (url, num) {
      this.step = num
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/permissionManger/permissionManger.vue